// ----------------------------------------------------------------------
// <copyright file="Izenda.TreeView.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var PropTypes = React.PropTypes;
  var ObservablePropTypes = require('mobx-react').propTypes;
  var TreeViewItemList = require('./TreeView/Izenda.TreeViewItemList');
  var ScrollBox = require('./Izenda.ScrollBox');
  var FlattenTreeUIStore = require('./TreeView/Izenda.FlattenTreeUIStore');

  var observer = require('mobx-react').observer;
  var asReference = require('mobx').asReference;
  const { curry, flatMap, isNil } = require('lodash/fp');
  var TreeView = React.createClass({
    flattenTree: null,
    propTypes: {
      nodes: ObservablePropTypes.arrayOrObservableArray,
      getChildNodes: PropTypes.func.isRequired,
      getKey: PropTypes.func.isRequired,
      renderNode: PropTypes.func.isRequired,
      collapsed: PropTypes.bool,
      nodeExpand: PropTypes.func
    },
    getDefaultProps: function() {
      return {
        collapsed: true
      };
    },
    componentWillMount: function() {
      this.flattenTree = new FlattenTreeUIStore();
    },
    render: function() {
      var props = this.props;
      var className = props.className;
      var nodes = props.nodes;
      var renderNode = props.renderNode;
      var getChildNodes = props.getChildNodes;
      var getKey = props.getKey;
      var nodeExpand = props.nodeExpand;
      var collapsed = props.collapsed;

      var flattenFirstLevelNode = curry(flatten, 6)(
        0, // node level. Zero is for root node.
        nodeExpand, // check whether node is expanded
        getChildNodes, // retrieve child nodes of a particular tree node
        getKey, // retrieve key value of a node. It must be unique
        collapsed, // tree is collapsed by default
        null // parent tree node. Null is for root node.
      );

      var flattenNodes = flatMap(flattenFirstLevelNode, nodes);

      return (
        <ScrollBox>
          <TreeViewItemList
            className={className}
            treeViewItemClassName={props.treeViewItemClassName}
            flattenNodes={flattenNodes}
            treeStore={this.flattenTree}
            renderNode={renderNode}
          />
        </ScrollBox>
      );
    }
  });

  function flatten(level, nodeExpand, getChildNodes, getKey, collapsed, parent, node) {
    if (!node) return [];

    var currentLevel = level;
    var key = getKey(node);
    var childNodeIndex, childrenLength, grandChildren;
    var nodeExpanded = !isNil(nodeExpand) && nodeExpand(node);
    var defaultExpanded = !collapsed;

    // Node is expanded if it's expanded by data logic, or by default setting
    // or by user actions.
    var shouldExpanded = nodeExpanded || defaultExpanded;

    var childNodes = getChildNodes(node) || [];

    var currentTreeNode = toTreeNode(currentLevel, key, shouldExpanded, childNodes.length, parent, node);

    var flattenList = [currentTreeNode];

    // Use native FOR loop to maximize performance while walking thru child nodes list.
    for (childNodeIndex = 0, childrenLength = childNodes.length; childNodeIndex < childrenLength; childNodeIndex++) {
      grandChildren = flatten(
        currentLevel + 1,
        nodeExpand,
        getChildNodes,
        getKey,
        collapsed,
        currentTreeNode,
        childNodes[childNodeIndex]
      );

      Array.prototype.push.apply(flattenList, grandChildren);
    }
    return flattenList;
  }

  function toTreeNode(level, key, shouldExpanded, childCount, parent, dataNode) {
    return {
      level: level,
      data: asReference(dataNode),
      key: key,
      parent: parent,
      childCount: childCount,
      expanded: shouldExpanded
    };
  }

  module.exports = observer(TreeView);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.TreeView.jsx